import { useEffect, useState } from 'preact/hooks';
import { api, connect, me, rings, toast, type Me } from './state';
import { Agents } from './views/Agents';
import { Chats } from './views/Chats';
import { History } from './views/History';
import { Leads } from './views/Leads';
import { Login } from './views/Login';
import { Replies } from './views/Replies';

type Tab = 'chats' | 'history' | 'leads' | 'agents' | 'replies';
const tabFromHash = (): Tab => (['chats', 'history', 'leads', 'agents', 'replies'].includes(location.hash.slice(1)) ? (location.hash.slice(1) as Tab) : 'chats');

export function App() {
  const [ready, setReady] = useState(false);
  const [tab, setTab] = useState<Tab>(tabFromHash());

  useEffect(() => {
    api<Me>('/me')
      .then((m) => {
        me.value = m;
        connect();
      })
      .catch(() => (me.value = null))
      .finally(() => setReady(true));
    const onHash = () => setTab(tabFromHash());
    addEventListener('hashchange', onHash);
    return () => removeEventListener('hashchange', onHash);
  }, []);

  if (!ready) return null;
  if (!me.value) return <Login />;

  const role = me.value.role;
  const tabs: [Tab, string][] = [['chats', 'Chats'], ['history', 'History']];
  if (role !== 'agent') tabs.push(['leads', 'Leads']);
  if (role === 'admin') tabs.push(['agents', 'Agents'], ['replies', 'Saved replies']);

  return (
    <div class="app">
      <header class="topbar">
        <img src="/logo-white.svg" alt="Guardian Access Solutions" class="brand" />
        <nav>
          {tabs.map(([t, label]) => (
            <a href={`#${t}`} class={tab === t ? 'on' : ''}>
              {label}
              {t === 'chats' && rings.value.length > 0 && <span class="count">{rings.value.length}</span>}
            </a>
          ))}
        </nav>
        <div class="who">
          <a class="link-light" href="/help/" target="_blank" rel="noopener">Help</a>
          <span>{me.value.name}</span>
          <button class="link-light" onClick={async () => { await api('/logout', { method: 'POST' }); location.reload(); }}>Sign out</button>
        </div>
      </header>
      <main class="main">
        {tab === 'chats' && <Chats />}
        {tab === 'history' && <History />}
        {tab === 'leads' && role !== 'agent' && <Leads />}
        {tab === 'agents' && role === 'admin' && <Agents />}
        {tab === 'replies' && role === 'admin' && <Replies />}
      </main>
      {toast.value && <div class="toast" role="status">{toast.value}</div>}
    </div>
  );
}
